import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseTrendPricePeriod.module.scss'

import { NCLICK } from '@Root/contants/lcs'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  period: number
  setPeriod: (period: number) => void
}

const MyhouseTrendPricePeriod: React.FC<Props> = ({ period, setPeriod }: Props) => {
  return (
    <div className={cx('myhouse_price_period')}>
      <button type="button" className={cx('price_period_button')} aria-selected={period === 1} onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.YEAR_1, () => setPeriod(1))}>
        1년
      </button>
      <button type="button" className={cx('price_period_button')} aria-selected={period === 3} onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.YEAR_3, () => setPeriod(3))}>
        3년
      </button>
      <button type="button" className={cx('price_period_button')} aria-selected={period === 5} onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.YEAR_5, () => setPeriod(5))}>
        5년
      </button>
      <button type="button" className={cx('price_period_button')} aria-selected={period === 7} onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.YEAR_7, () => setPeriod(7))}>
        7년
      </button>
    </div>
  )
}

export default MyhouseTrendPricePeriod
